import {
    Direction,
    DisplayFeature,
    Operation
} from "./presentation/routes/contract-features-3/domain";

export default class datafangstHelpers {

    /**
     * @param n string to pad
     * @param width wanted
     * @param z optional value to pad with. If not supplied 0 is used.
     * @returns {*}
     */
    static pad(n: number, width: number, z?: string): string {
        z = z || '0';
        let str = n + '';
        return str.length >= width ? str : new Array(width - str.length + 1).join(z) + n;
    }

    static months = ['Jan', 'Feb', 'Mar', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Des'];

    static formatDate(date: Date): string {
        return date.getDate() + '/' + datafangstHelpers.months[date.getMonth()] + '/' + (date.getFullYear() % 100) + ' '
            + datafangstHelpers.pad(date.getHours(), 2)
            + ':' + datafangstHelpers.pad(date.getMinutes(), 2) + ':'
            + datafangstHelpers.pad(date.getSeconds(), 2);
    }

    static values(object: any) {
        return Object.keys(object).map(key => object[key]);
    }

    static degreesToRadians(degrees: number): number {
        return degrees * (Math.PI / 180);
    }

    static operationToDomain(operation: string) : Operation {
        switch (operation) {
            case "Opprett":
                return "CREATE";
            case "Korriger":
                return "CORRECT";
            case "Oppdater":
                return "UPDATE";
            case "Lukk":
                return "CLOSE";
            default:
                throw "Unexpected operation";
        }
    }

    static operationFromDomain(operation: string): string {
        switch (operation) {
            case "CREATE":
                return "Opprett";
            case "CORRECT":
                return "Korriger";
            case "UPDATE":
                return "Oppdater";
            case "CLOSE":
                return "Lukk";
            default:
                return operation;
        }
    }

    static allLocationalsSameMeteringDirection(feature: DisplayFeature): boolean {
        const directions = feature.locational.locationals.map(locational => locational.meteringDirection);
        return directions.every(direction => direction === directions[0]);
    }

    static getMeteringDirection(feature: DisplayFeature): Direction {
        if (this.allLocationalsSameMeteringDirection(feature)) {
            return feature.locational.locationals[0].meteringDirection;
        } else {
            throw "Kan ikke finne metreringsretning på objekt når ikke alle metreringsretninger er like."
        }
    }

    static validateRoadSystemReference(reference: string) {
        const trimmed = (reference ?? '').replace(/\s/g, '');
        // REF: https://www.vegdata.no/wp-content/uploads/2019/11/20191115-Reform-og-nytt-vegreferansesystem.pdf
        const regex = /[ERFKPS][PAVF][1-9][0-9]*S([1-9][0-9]*)D[1-9][0-9]*[JN]?((MED|N|MOT)([0-9]+-[0-9]+))?[GK]?[0-9]*(M[0-9]+)(-M?[0-9]+)?([SK]D[0-9]+([GK])?((M[0-9]+)(-M?[0-9]+)?))?/gi;
        return regex.test(trimmed);
    }

    static extractInfoFromSystemRef(text: string) {
        const trimmed = (text ?? '').replace(/\s/g, '');
        const valid = datafangstHelpers.validateRoadSystemReference(text);

        const error = valid ? '' : 'Referansen ser ugyldig ut';
        const meters = /(M[0-9]+(-M?[0-9]+)?)(?!.)/gi.exec(trimmed);
        const meterValue = meters && meters[0] ? meters[0] : '-';
        const [a, b = ''] = meterValue.split('-');
        const [before] = trimmed.split(meterValue);
        return {trimmed, valid, error, before, a, b};
    }
}
